// extracted by mini-css-extract-plugin
export default {"dropDown":"TablePager_dropDown__7RhbG","pager":"TablePager_pager__pHX0-"};